// Total products per page - 786/ALLAH - SM team changed here
var boostPFSFilterConfig = { 
  general: { 
    limit: 68,
    loadProductFirst: false, 
    showLimitList: "12,16,20,24,50,60,68", 
    filterHorizontalColumn: "3", 
    keepScrollbackPositionType: "history",
    paginationType: 'load_more',
  } 
};

(function () {
    BoostPFS.inject(this);
    ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        if (!totalProduct) totalProduct = this.totalProduct;
        var images = data.images_info;
        var soldOut = !data.available;
        var onSale = data.compare_at_price_min > data.price_min;
        var priceVaries = data.price_min != data.price_max;
        var firstVariant = data.variants[0];
        if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
            var paramVariant = data.variants.filter(function (e) {
                return e.id == Utils.getParam("variant");
            });
            if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data.variants.length; i++) {
                if (data.variants[i].available) {
                    firstVariant = data.variants[i];
                    break;
                }
            }
        }
        var itemHtml = "";
        if (boostPFSConfig.custom.style_product_grid == "style_product_grid_2") {
            itemHtml = boostPFSTemplate.productGridItem2Html;
        } else {
            itemHtml = boostPFSTemplate.productGridItemHtml;
        }
      
      	 // Add grid - Set 4 columns grid by default SM - 786/ALLAH
    	 itemHtml = itemHtml.replace(/{{grid_item_width}}/g, "col-6 col-md-4 col-lg-3");//boostPFSConfig.custom.grid_item_width

         //itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
      
        itemHtml = boostPFSConfig.custom.product_image_border ? itemHtml.replace(/{{itemGridBorderClass}}/g, boostPFSTemplate.gridBorderClass) : itemHtml.replace(/{{itemGridBorderClass}}/g, "");
        itemHtml = boostPFSConfig.custom.product_image_crop ? itemHtml.replace(/{{itemCropImageClass}}/g, "crop_image") : itemHtml.replace(/{{itemCropImageClass}}/g, "no_crop_image");
        itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, boostPFSTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, "");
        itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, boostPFSTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, "");
        itemHtml = itemHtml.replace(/{{delayTime}}/g, boostPFSConfig.custom.time_lazy_load * index);
        var aspect_ratio = images.length > 0 ? images[0].width / images[0].height : 1;
        var itemImagesHtml = "";
        var itemStylesHtml = "";
        if (!boostPFSConfig.custom.product_image_resize) {
            itemStylesHtml += 'style="padding-top: ' + (1 / aspect_ratio) * 100 + '%"';
        }
        if (images.length > 1 && boostPFSConfig.custom.image_swap) {
            itemImagesHtml +=
                '<picture data-index="0">' +
                '<source data-skafos-similar-image data-srcset="' +
                Utils.optimizeImage(images[0].src, "360x") +
                '" media="(max-width: 767px)" />' +
                '<source data-skafos-similar-image data-srcset="' +
                buildDataSrcset(images[0].src) +
                '" media="(min-width: 768px)" />' +
                '<img data-skafos-similar-image alt="{{itemTitle}}" class="images-one lazyload" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' +
                aspect_ratio +
                '" data-sizes="auto" data-srcset="' +
                buildDataSrcset(images[0].src) +
                '" data-image>' +
                "</picture>" +
                '<span class="images-two">' +
                '<picture data-index="1">' +
                '<source data-skafos-similar-secondary-image data-srcset="' +
                Utils.optimizeImage(images[1].src, "360x") +
                '" media="(max-width: 767px)"/>' +
                '<source data-skafos-similar-secondary-image data-srcset="' +
                buildDataSrcset(images[1].src) +
                '" media="(min-width: 768px)" />' +
                '<img data-skafos-similar-image alt="{{itemTitle}}" class="lazyload" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' +
                aspect_ratio +
                '" data-sizes="auto" data-srcset="' +
                buildDataSrcset(images[1].src) +
                '" data-image>' +
                "</picture>" +
                "</span>";
        } else {
            var imgSrc = images.length > 0 ? images[0].src : boostPFSConfig.general.no_image_url;
            itemImagesHtml +=
                '<picture data-index="0">' +
                '<source data-srcset="' +
                Utils.optimizeImage(imgSrc, "360x") +
                '" media="(max-width: 767px)" />' +
                '<source data-srcset="' +
                buildDataSrcset(imgSrc) +
                '" media="(min-width: 768px)" />' +
                '<img data-skafos-similar-image alt="{{itemTitle}}" class="lazyload" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' +
                aspect_ratio +
                '" data-sizes="auto" data-srcset="' +
                buildDataSrcset(imgSrc) +
                '" data-image>' +
                "</picture>";
        }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
        itemHtml = itemHtml.replace(/{{itemStyles}}/g, itemStylesHtml);
        var itemThumbUrl = images.length > 0 ? images[0].src : boostPFSConfig.general.no_image_url;
        var itemFlipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1].src, "1024x1024") : itemThumbUrl;
        if (Globals.queryParams.hasOwnProperty("pf_opt_color")) {
            var selectedColors = Globals.queryParams.pf_opt_color;
            for (var k = 0; k < selectedColors.length; k++) {
                var selectedColor = selectedColors[k].toLowerCase();
                for (var i = 0; i < data.variants.length; i++) {
                    var variant = data.variants[i];
                    if (variant.hasOwnProperty("merged_options") && variant.merged_options.length > 0) {
                        for (var j = 0; j < variant.merged_options.length; j++) {
                            var mergeValue = variant.merged_options[j].toLowerCase();
                            if (mergeValue.indexOf(selectedColor) > -1 && variant.image) {
                                var itemThumbUrl = variant.image;
                                break;
                            }
                        }
                    }
                }
            }
        }
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
        var itemFlipImageLabel = images.length > 1 ? "image-swap " : "";
        itemHtml = itemHtml.replace(/{{itemFlipImageLabel}}/g, itemFlipImageLabel);
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
        itemHtml = itemHtml.replace(/{{itemFlipImageUrl}}/g, itemFlipImageUrl);
        var itemLabelsHtml = "";
        if (onSale || soldOut) {
            itemLabelsHtml += '<div class="product-label">';
            if (onSale) {
                itemLabelsHtml += '<strong class="label sale-label">' + boostPFSConfig.label.sale + "</strong>";
            }
            if (soldOut) {
                itemLabelsHtml += '<strong class="label sold-out-label">' + boostPFSConfig.label.sold_out + "</strong>";
            }
            itemLabelsHtml += "</div>";
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
        var itemPriceHtml = "";
        if (onSale) {
            itemPriceHtml += '<p class="sale">';
            itemPriceHtml += '<span class="old-price"> ' + Utils.formatMoney(data.compare_at_price_min) + "</span>";
            itemPriceHtml += '<span class="special-price">';
            if (priceVaries) {
                itemPriceHtml += "<em class='line_break'>" + boostPFSConfig.label.from_price + " </em>";
            }
            itemPriceHtml += Utils.formatMoney(data.price_min);
            itemPriceHtml += "</span>";
            itemPriceHtml += "</span></p>";
        } else {
            itemPriceHtml += '<p class="regular-product"><span>';
            if (priceVaries) {
                itemPriceHtml += "<em class='line_break'>" + boostPFSConfig.label.from_price + " </em>";
            }
            itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
            itemPriceHtml += "</span></p>";
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      
    //To set price for Klarna - 786/ALLAH
    var price_no_format = parseInt(data.price_min*100);
    itemHtml = itemHtml.replace(/{{itemPrice1}}/g, price_no_format);
    
    if(soldOut) {
  		itemHtml = itemHtml.replace(/{{itemAvailable}}/g, " disabled");
    } else {
    	itemHtml = itemHtml.replace(/{{itemAvailable}}/g, "");
    }
    
    itemHtml = itemHtml.replace(/{{sizeLoading}}/g, window.sm_size_load);
    
    //Show loader when size swatches being displayed then only. - 786
   	var check_prd = "";
    
    if(data.variants.length > 1) {
    check_prd = "show";
    } else {
    check_prd = "hide";
    }
    
    itemHtml = itemHtml.replace(/{{showLoader}}/g, check_prd);
    
    //Set save % badge - 786
    if(data.variants[0].compare_at_price != null && data.variants[0].compare_at_price > data.variants[0].price) {
      var saving_amt = Math.round((data.variants[0].compare_at_price - data.variants[0].price)*100/data.variants[0].compare_at_price);   
      var saving_amt_html = '<div class="product-label"><strong class="label sale-label">-'+saving_amt+'%</strong><br></div>';
      
      itemHtml = itemHtml.replace(/{{itemSavingAmt}}/g, saving_amt_html);
      
    } else {
      itemHtml = itemHtml.replace(/{{itemSavingAmt}}/g, "");
    }
    
    //Set delivery icon. - 786
    itemHtml = itemHtml.replace(/{{deliveryIcon}}/g, window.sm_dis_icon);
    
    //Set AR Icon. - 786
    itemHtml = itemHtml.replace(/{{arIcon}}/g, window.sm_ar_icon);

    //AR Mobile View - 786
    var ar_mobile_btn = ''; 
    var variant_barcode = '';
      
    if(data.variants[0].barcode != "" && data.variants[0].barcode != null) {
      variant_barcode = data.variants[0].barcode.trim();
    }

    ar_mobile_btn = '<button type="button" name="sm_ar_visualizer" class="sm_ar_visualizer"><a class="go_to_ar" href="https://lite.actumwork.pl/AR/ec27475a02ecf742e19a2b34692253fb1367a1fa4b930e1368b29704299afae67bdac3487fc5543903c04851b467db1920b6?sku='+variant_barcode+'" target="_blank"><img data-swift-lazy="1" loading="lazy" src="'+window.ar_mobile_icon+'" alt="" /><span class="sm_btn_texts"><span class="sm_btn_abv_txt">VIEW IN YOUR ROOM</span></span></a></button>';
  
    itemHtml = itemHtml.replace(/{{arMobileBtn}}/g, ar_mobile_btn);

      let stHasSale = 0;
        let stInventory = 0;
        for(const key in data.variants){
          const variant = data.variants[key]
          if(variant.available && variant.inventory_management != null && variant.inventory_quantity > 0){
            stInventory += variant.inventory_quantity
          }
          if(variant.compare_at_price > variant.price){
            stHasSale = 1
          }
        }
      let stCollections = ''
      for(const key in data.collections){
        stCollections += `${data.collections[key].id},`
      }
      let stTags = ''
      for(const tag in data.tags){
        stTags += `${data.tags[tag]},`
      }
      
        const shineAttrs = ` data-created-at="${moment(data.created_at).format("YYYY-MM-DD HH:mm:ss")}" 
        data-on-sale="${stHasSale}" 
        data-inventory="${stInventory}" 
        data-collections="${stCollections}"
        data-tags="${stTags}"
        data-title="${data.title.replace("'", "&#x27;")}"
        data-id="${data.id}"
        data-handle="${data.handle}"
        data-available="${data.available}"
        data-price="${data.price ? data.price: 0 }"
        data-price-min="${data.price_min}"
        data-price-max="${data.price_max}"
        data-compare-at-price="${data.compare_at_price ? data.compare_at_price : 0}"
        data-vendor="${data.vendor}"
        data-type="${data.type ? data.type : ''}"`

      itemHtml = itemHtml.replace(/{{shinetrust}}/g, shineAttrs);
        
    //Ends here - 786
      
   	//Get Stock data
   	var variant_policy = data.variants[0].inventory_policy;
   	var variant_qty = data.variants[0].inventory_quantity;
   
   	if(data.variants[0].inventory_management == 'shopify') {
   
     if(variant_policy == 'continue') {
    
       if(variant_qty < 1) {
    		var msg_text = data.variants[0].option_stock;
    		var show_icon = "no";
        } else {
   			var msg_text = window.sm_in_stock_txt;
    		var show_icon = "yes";
        }
    
    } else {
  	   //DENY	
       if(variant_qty < 1) {	
   		var msg_text = "";
    	var show_icon = "no";  
       } else {	
    	var msg_text = window.sm_in_stock_txt;
        var show_icon = "yes";
       }
    }
    
    } else {
   		//Do not track inventory
   		var msg_text = window.sm_in_stock_txt;
    	var show_icon = "yes";
    }
    
   	//Dispatch text.
    var item_del_html = "";
     
    if(msg_text != "") {
      if(show_icon == "yes") {
        item_del_html += '<div class="sm_dispatch_msg_with_icon"><p><strong>Delivery Time:</strong></p><p><span class="sm_dis_icon"><img src="'+window.sm_dis_icon+'" alt="sm-truck-icon" /></span><span class="sm_dis_txt">'+msg_text+'</span></p></div>';
      } else {
        item_del_html += '<div class="sm_dispatch_msg"><p><strong>Delivery Time:</strong></p><p><span class="sm_dis_txt">'+msg_text+'</span></p></div>';
      }   
    }
      
    itemHtml = itemHtml.replace(/{{itemDeliveryDetails}}/g, item_del_html);
    //Ended here - 786/92
      
        var itemVendorHtml = "";
        if (boostPFSConfig.custom.show_vendor) {
            itemVendorHtml = '<div class="product-vendor">' + data.vendor + "</div>";
        }
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
        var itemCompareHtml = "";
        if (boostPFSConfig.custom.enable_compare_product) {
            itemCompareHtml += '<a class="compare-button" data-icon-compare href="javascript:void(0)" data-compare-product-handle="{{itemHandle}}" data-id="{{itemId}}" title="' + boostPFSConfig.label.add_to_compare + '">';
            itemCompareHtml += '<span ckass="compare-text" ';
            if (boostPFSConfig.custom.style_product_grid == "style_product_grid_3") {
                itemCompareHtml += "data-change-text-compare";
            }
            itemCompareHtml += ">";
            if (boostPFSConfig.custom.style_product_grid == "style_product_grid_3") {
                itemCompareHtml += boostPFSConfig.label.add_to_compare;
            } else {
                itemCompareHtml += boostPFSConfig.label.compare_title;
            }
            if (boostPFSConfig.custom.style_product_grid == "style_product_grid_2") {
                itemCompareHtml +=
                    '<svg class="icon" viewBox="0 0 1024 1024"><path d="M815.415 818.951c-15.614 0-28.278-12.667-28.278-28.278v-489.739c0-43.452-35.349-78.8-78.8-78.8h-145.669c-15.614 0-28.278-12.667-28.278-28.278s12.667-28.278 28.278-28.278h145.669c74.676 0 135.36 60.684 135.36 135.36v489.739c0 15.614-12.667 28.278-28.278 28.278z"></path><path d="M595.808 309.182c-6.039 0-12.078-2.062-16.938-6.481l-86.606-76.884c-8.395-7.513-13.257-18.265-13.257-29.605s4.861-22.095 13.257-29.605l86.606-77.034c10.458-9.426 26.659-8.395 35.939 2.062s8.395 26.659-2.062 35.939l-77.034 68.49 77.034 68.49c10.458 9.426 11.489 25.481 2.062 35.939-5.008 5.891-11.93 8.69-18.999 8.69z"></path><path d="M447.194 822.045h-145.669c-74.676 0-135.36-60.684-135.36-135.36v-489.885c0-15.614 12.667-28.278 28.278-28.278s28.278 12.667 28.278 28.278v489.739c0 43.452 35.349 78.8 78.8 78.8h145.669c15.614 0 28.278 12.667 28.278 28.278 0 15.76-12.667 28.428-28.278 28.428z"></path><path d="M414.053 904.231c-7.069 0-13.994-2.946-18.999-8.543-9.28-10.458-8.395-26.659 2.062-35.939l77.034-68.49-77.034-68.49c-10.458-9.426-11.489-25.481-2.062-35.939 9.426-10.458 25.481-11.489 35.939-2.062l86.606 76.884c8.395 7.513 13.257 18.265 13.257 29.605s-4.861 22.095-13.257 29.605l-86.606 76.884c-4.861 4.419-11.046 6.481-16.938 6.481z"></path></svg>';
            }
            itemCompareHtml += "</span>";
            itemCompareHtml += "</a>";
        }
        itemHtml = itemHtml.replace(/{{itemCompare}}/g, itemCompareHtml);
        var itemAddToCartHtml = "";
        if (boostPFSConfig.custom.display_button) {
            var itemAddToCartHtml = '<div class="action"><form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
            if (soldOut) {
                itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + boostPFSConfig.label.unavailable + '" disabled="disabled"/>';
            } else {
                if (data.variants.length > 1) {
                    itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + boostPFSConfig.label.select_options + '" />';
                } else {
                    itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
                    itemAddToCartHtml +=
                        '<button data-btn-addtocart="" class="btn add-to-cart-btn" type="submit" data-form-id="#product-actions-{{itemId}}" data-translate="products.product.add_to_cart">' + boostPFSConfig.label.add_to_cart + "</button>";
                }
            }
            itemAddToCartHtml += "</form></div>";
        }
        itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);
        var relatedCollection = window.location.pathname + "?view=related";
        itemHtml = itemHtml.replace(/{{itemCollectionRelated}}/g, relatedCollection);
        itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildSizeSwatches(data));
        var itemQuickViewHtml = "";
        if (boostPFSConfig.custom.enable_quick_view) {
            itemQuickViewHtml = boostPFSTemplate.quickViewHtml;
        }
        itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);
        if (typeof Integration !== "undefined" && !Integration.hascompileTemplate("reviews")) {
            var itemReviewHtml = boostPFSConfig.custom.display_product_reviews ? boostPFSTemplate.reviewHtml : "";
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
        }
        var itemMoreSizes = "";
        if (data.variants.length > 0) {
            itemMoreSizes = '<span class="text-size">' + boostPFSConfig.label.size + "</span>";
        }
        itemHtml = itemHtml.replace(/{{itemMoreSizes}}/g, itemMoreSizes);
        itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));
        var itemDescription = "";
        if (data.body_html != "") {
            itemDescription = jQ("<p>" + data.body_html + "</p>").text();
            var tempArr = itemDescription.split("[/countdown]");
            itemDescription = tempArr.pop();
            itemDescription = Utils.truncateByWord(itemDescription, 50);
        }
        itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
        var itemTitleMultilangHtml = "";
        if (boostPFSConfig.custom.enable_multilang && data.title.indexOf("|") !== null) {
            var titleMultilang = data.title.split("|");
            itemTitleMultilangHtml += '<span class="lang1">' + titleMultilang[0].trim() + '</span><span class="lang2">' + titleMultilang[1].trim() + "</span>";
        } else {
            itemTitleMultilangHtml += "<span>" + data.title.split("|")[0] + "</span>";
        }
        itemHtml = itemHtml.replace(/{{itemTitleMultilang}}/g, itemTitleMultilangHtml);
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{skafosProductId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{skafosCollectionId}}/g, window.skafosCollectionId);
        itemHtml = itemHtml.replace(/{{skafosProductCount}}/g, window.skafosProductCount);
        return itemHtml;
    };
    ProductListItem.prototype.compileTemplate = function (data, index, totalProduct) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        if (!totalProduct) totalProduct = this.totalProduct;
        var images = data.images_info;
        var soldOut = !data.available;
        var onSale = data.compare_at_price_min > data.price_min;
        var priceVaries = data.price_min != data.price_max;
        var firstVariant = data.variants[0];
        if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
            var paramVariant = data.variants.filter(function (e) {
                return e.id == Utils.getParam("variant");
            });
            if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data.variants.length; i++) {
                if (data.variants[i].available) {
                    firstVariant = data.variants[i];
                    break;
                }
            }
        }
        var itemHtml = boostPFSTemplate.productListItemHtml;
        itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, boostPFSTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, "");
        itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, boostPFSTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, "");
        itemHtml = itemHtml.replace(/{{delayTime}}/g, boostPFSConfig.custom.time_lazy_load * index);
        var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0].src) : boostPFSConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
        var itemLabelsHtml = "";
        if (onSale || soldOut) {
            itemLabelsHtml += '<div class="product-label">';
            if (onSale) {
                itemLabelsHtml += '<strong class="label">' + boostPFSConfig.label.sale + "</strong>";
            }
            if (soldOut) {
                itemLabelsHtml += '<strong class="sold-out-label">' + boostPFSConfig.label.sold_out + "</strong>";
            }
            itemLabelsHtml += "</div>";
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
        var itemPriceHtml = "";
        if (onSale) {
            itemPriceHtml += '<p class="sale">';
            itemPriceHtml += '<span class="old-price money"> ' + Utils.formatMoney(data.compare_at_price_min) + "</span>";
            if (priceVaries) {
                itemPriceHtml += '<span class="special-price"><em class="line_break">' + boostPFSConfig.label.from_price + " </em>";
            } else {
                itemPriceHtml += '<span class="special-price">';
            }
            itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
            itemPriceHtml += "</span></p>";
        } else {
            itemPriceHtml += '<p class="regular-product">';
            if (priceVaries) {
                itemPriceHtml += '<span class="money"><em class="line_break">' + boostPFSConfig.label.from_price + " </em>" + Utils.formatMoney(data.price_min) + "</span>";
            } else {
                itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min) + "</span>";
            }
            itemPriceHtml += "</p>";
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
        var itemVendorHtml = "";
        if (boostPFSConfig.custom.show_vendor) {
            itemVendorHtml = '<div class="product-vendor">' + data.vendor + "</div>";
        }
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
        var itemAddToCartHtml = '<form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
        if (soldOut) {
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + boostPFSConfig.label.unavailable + '" disabled="disabled"/>';
        } else {
            if (data.variants.length > 1) {
                itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + boostPFSConfig.label.select_options + '" />';
            } else {
                itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
                itemAddToCartHtml += '<input class="btn add-to-cart-btn" data-form-id="#product-actions-{{itemId}}" type="submit" value="' + boostPFSConfig.label.add_to_cart + '" />';
            }
        }
        itemAddToCartHtml += "</form>";
        itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);
        var itemQuickViewHtml = "";
        if (boostPFSConfig.custom.enable_quick_view) {
            itemQuickViewHtml = boostPFSTemplate.quickViewHtml;
        }
        itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);
        if (typeof Integration === "undefined" || !Integration.hascompileTemplate("reviews")) {
            var itemReviewHtml = boostPFSConfig.custom.display_product_reviews ? boostPFSTemplate.reviewHtml : "";
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
        }
        itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));
        var itemDescription = "";
        if (data.body_html.indexOf("[countdown]") !== -1) {
            itemDescription = jQ("<p>" + data.body_html + "</p>").text();
            var tempArr = itemDescription.split("[/countdown]");
            itemDescription = tempArr.pop();
            itemDescription = Utils.truncateByWord(itemDescription, 50);
        }
        itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
        var itemTitleMultilangHtml = "";
        if (boostPFSConfig.custom.enable_multilang && data.title.indexOf("|") !== null) {
            var titleMultilang = data.title.split("|");
            itemTitleMultilangHtml += '<span class="lang1">' + titleMultilang[0].trim() + '</span><span class="lang2">' + titleMultilang[1].trim() + "</span>";
        } else {
            itemTitleMultilangHtml += "<span>" + data.title.split("|")[0] + "</span>";
        }
        itemHtml = itemHtml.replace(/{{itemTitleMultilang}}/g, itemTitleMultilangHtml);
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{skafosProductId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{skafosCollectionId}}/g, window.skafosCollectionId);
        itemHtml = itemHtml.replace(/{{skafosProductCount}}/g, window.skafosProductCount);
        return itemHtml;
    };
    function buildWishlist(data) {
        if (!data) data = this.data;
        var wishlistHtml = "";
        if (boostPFSConfig.custom.enable_wishlist) {
            var value = data.id.toString();
            var productId = data.id.toString();
            for (var k = 0; k < boostPFSConfig.customer.tags.length; k++) {
                var tagID = boostPFSConfig.customer.tags[k];
                if (tagID.indexOf(productId) > -1) {
                    value = "x" + tagID;
                }
                if (value.length == 0) value = productId;
            }
            if (value.length > 0) {
                var check = ((value.length - productId.length) / 2).toString();
                check = check.split(".");
                var display = check.length > 1 && check[1].indexOf("5") > -1 ? !1 : !0;
            }
            wishlistHtml += '<a class="wishlist" data-icon-wishlist href="#" data-product-handle="' + data.handle + '"title="' + boostPFSConfig.label.wishlist_note + '" data-id="' + data.id + '">' + boostPFSTemplate.wishlistHtml + "</a>";
        }
        return wishlistHtml;
    }
    function buildSizeSwatches(data) {
        if (!data) data = this.data;
        var sizeSwatchesHtml = "";
        if (boostPFSConfig.custom.enable_size_swatch && data.available && data.variants.length > 0) {
            sizeSwatchesHtml += '<ul class="sizes-list">';
            for (var index = 0; index < data.options.length; index++) {
                var option = data.options[index].toLowerCase();
                if (option == "size") {
                    var sizelist = "";
                    var size = "";
                    var totalVariants = 0;
                    for (var k = 0; k < data.variants.length; k++) {
                        var variant = data.variants[k];
                        size = variant.options[index];
                        if (sizelist.indexOf(size) == -1) {
                            if (totalVariants < 4) {
                                sizeSwatchesHtml += '<li class="size-item">';
                                sizeSwatchesHtml += '<a title="' + size + '" href="' + Utils.buildProductItemUrl(data) + "?variant=" + variant.id + '">' + size + "</a>";
                                sizeSwatchesHtml += "</li>";
                            }
                            var templist = sizelist + size + " ";
                            sizelist = templist;
                            totalVariants++;
                        }
                    }
                    if (totalVariants >= 4) {
                        sizeSwatchesHtml += '<li class="item-size-more">';
                        sizeSwatchesHtml += '<a href="{{itemUrl}}" title="More Size">+' + (totalVariants - 3) + "</a>";
                        sizeSwatchesHtml += "</li>";
                        totalVariants = 0;
                    }
                }
            }
            sizeSwatchesHtml += "</ul>";
        }
        return sizeSwatchesHtml;
    }
    function buildColorSwatches(data) {
        if (!data) data = this.data;
        var colorSwatchesHtml = "";
        if (boostPFSConfig.custom.display_item_swatch) {
            colorSwatchesHtml += '<ul class="item-swatch">';
            for (var index = 0; index < data.options.length; index++) {
                var option = data.options[index].toLowerCase();
                if (option == "color") {
                    var colorlist = "";
                    var color = "";
                    var totalVariants = 0;
                    for (var k = 0; k < data.variants.length; k++) {
                        var variant = data.variants[k];
                        color = variant.options[index];
                        if (colorlist.indexOf(color) == -1) {
                            if (totalVariants < 4) {
                                var text = Utils.slugify(color);
                                var border = text == "white" ? "border: 1px solid #cbcbcb;" : "";
                                var backgroundImage = Utils.optimizeImage(variant.image, "24x");
                                var dataImg = "";
                                var dataColor = "#fff";
                                if (variant.image !== null) {
                                    dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
                                } else {
                                    var _file = variant.option_color.toLowerCase().replace(/ /g, "-");
                                    var dataColors = variant.option_color.toLowerCase().split(" ");
                                    var i = dataColors.length - 1;
                                    if (dataColors[i] !== "" && dataColors[i] !== "colors") {
                                        dataColor = dataColors[i];
                                    }
                                    backgroundImage = boostPFSConfig.general.asset_url.replace("boost-pfs.js", _file + ".png");
                                }
                                colorSwatchesHtml += "<li>";
                                colorSwatchesHtml += '<div class="tooltip">' + color + "</div>";
                                colorSwatchesHtml += '<label style="' + border + "background-image: url(" + backgroundImage + "); background-color: " + dataColor + ';"' + dataImg + "></label>";
                                colorSwatchesHtml += "</li>";
                            }
                            var templist = colorlist + color + " ";
                            colorlist = templist;
                            totalVariants++;
                        }
                    }
                    if (totalVariants > 4) {
                        colorSwatchesHtml += '<li class="item-swatch-more">';
                        colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+' + (totalVariants - 4) + "</a>";
                        colorSwatchesHtml += "</li>";
                        totalVariants = 0;
                    }
                }
            }
            colorSwatchesHtml += "</ul>";
        }
        return colorSwatchesHtml;
    }
    function buildDataSrcset(imageSrc) {
        var html = Utils.optimizeImage(imageSrc, "360x") + " 360w, " + Utils.optimizeImage(imageSrc, "540x") + " 540w, " + Utils.optimizeImage(imageSrc, "720x") + " 720w, " + Utils.optimizeImage(imageSrc, "720x") + " 900w";
        return html;
    }
    
      ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift("...");
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push("...");
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            var pageItemsHtml = "";
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
          
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == "...") {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }
        return "";
    };
    ProductSorting.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
            var self = this;
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                var sortingItemsHtml = "";
                var currentValue = "";
                for (var k in sortingArr) {
                    if (Globals.queryParams.sort == k) {
                        currentValue = sortingArr[k];
                        var activeClass = " active";
                    } else {
                        var activeClass = "";
                    }
                    sortingItemsHtml += '<li data-boost-sort-value="' + sortingArr[k] + '" data-boost-sort="' + k + '" class="' + activeClass + '"><span>' + sortingArr[k] + "</span></li>";
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                html = currentValue == "" ? html.replace(/{{sort_by_label}}/g, "Sort by") : html.replace(/{{sort_by_label}}/g, currentValue);
                return html;
            }
        }
        return "";
    };
    ProductSorting.prototype.bindEvents = function () {
        var _this = this;
        var $sortingSelector = jQ(Selector.topSorting);
        $sortingSelector.find("li").on('click', function (e) {
            e.preventDefault();
            jQ(this).addClass("active");
            jQ(this).siblings().removeClass("active");
            var currentValue = jQ(this).data("boost-sort-value");
            $sortingSelector.find(".label-text").empty().text(currentValue);
            FilterApi.setParam("sort", jQ(this).data("boost-sort"));
            FilterApi.setParam("page", 1);
            FilterApi.applyFilter("sort");
        });
    };
    ProductLimit.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty("showLimitHtml")) {
            var numberList = Settings.getSettingValue("general.showLimitList");

            if (numberList != "") {
                var showLimitItemsHtml = "";
                var arr = numberList.split(",");
                for (var k = 0; k < arr.length; k++) {
                    if (arr[k] == Globals.queryParams.limit) {
                        showLimitItemsHtml += '<li class="active"><span data-boost-limit-value="' + arr[k] + '">' + arr[k] + "</span></li>";
                    } else {
                        showLimitItemsHtml += '<li><span data-boost-limit-value="' + arr[k] + '">' + arr[k] + "</span></li>";
                    }
                }
                var html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
                html = html.replace(/{{currentLimitItem}}/g, Globals.queryParams.limit);
                return html;
            }
        }
        return "";
    };
    ProductLimit.prototype.bindEvents = function () {
        var $topShowLimit = jQ(Selector.topShowLimit);
        $topShowLimit.find("li").on('click', function (e) {
            jQ(this).addClass("active");
            jQ(this).siblings().removeClass("active");
            var currentLimit = jQ(this).find("span").data("boost-limit-value");
            $topShowLimit.find("label-text").empty().text(currentLimit);
            FilterApi.setParam("limit", currentLimit);
            FilterApi.setParam("page", 1);
            FilterApi.applyFilter();
        });
    };
    ProductList.prototype.afterRender = function (data) {
        if (!data) data = this.data;
        var chunk = 10;
        var productBatch = [];
        for (var i = 0; i < data.length; i += chunk) {
            productBatch.push(data.slice(i, i + chunk));
        }
        var self = this;
        var productCounter = 0;
        productBatch.forEach(function (products) {
            self.buildExtrasProductListByAjax(products, "boost-integration", function (results) {
                results.forEach(function (result) {
                    jQ('[data-id="' + result.id + '"] .boost-custom-html')
                        .empty()
                        .html(result.custom_html);
                });
            });
        });
        if (typeof bcElla != "undefined") {
            bcElla.initAddToCart();
            bcElla.initGroupedAddToCart();
            bcElla.changeQuantityAddToCart();
            bcElla.initStickyAddToCart();
            bcElla.initQuickView();
            bcElla.initColorSwatchGrid();
        }
        var activeClass = "";
        var activeViewAs = jQ(".view-mode").find(".active").data("col");
        switch (activeViewAs) {
            case 1:
                activeClass = "col-12";
                break;
            case 2:
                activeClass = "col-6";
                break;
            case 3:
                activeClass = "col-6 col-md-4";
                break;
            case 4:
                activeClass = "col-6 col-md-4 col-lg-3";
                break;
            default:
                activeClass = "col-6 col-md-4 col-lg-3 col5";
        }
        jQ(Selector.products).find(".grid-item").removeClass(boostPFSConfig.custom.grid_item_width).addClass(activeClass);
        if (window.skafosSeeSimilar) window.skafosSeeSimilar("skafosSimilarProductTemplate", window.productClone, window.skafosSeeSimilarConfig);
    };
    gridItemsAlignBySM = function(){
        //BELOW func. added by SM team to align reviews, product title and price in 2024 FEB - 786/92/313/ASKMPF
        var gridRows = []; 
        var tempRow = [];
        var blogGridElements = jQ('.boost-pfs-filter-products > .grid-item');      
    
        blogGridElements.each(function(index) {
        	if(jQ(this).css('clear') != 'none' && index != 0) {
            	gridRows.push(tempRow); 
            	tempRow = []; 
        	}
        	
            tempRow.push(this);
 
        	if(blogGridElements.length == index + 1) {
            	gridRows.push(tempRow);
      	}
    	});

    	jQ.each(gridRows, function () {
        	var tallestHeight = 0;//title
            var tallestHeight1 = 0;//price
            var tallestHeight2 = 0;//review
      
      		jQ.each(this, function () {
        		jQ(this).find('.product-title').css('height', '');
                jQ(this).find('.price-box').css('height', '');
                jQ(this).find('.rug_review').css('height', '');
        		
        		var elHeight = parseInt(jQ(this).find('.product-title').height());
       			var elHeight1 = parseInt(jQ(this).find('.price-box').height());
                var elHeight2 = parseInt(jQ(this).find('.rug_review').height());

       			if (elHeight > tallestHeight) { tallestHeight = elHeight; }
                if (elHeight1 > tallestHeight1) { tallestHeight1 = elHeight1; }
                if (elHeight2 > tallestHeight2) { tallestHeight2 = elHeight2; }
      		});

     		jQ.each(this, function () {
        	 jQ(this).find('.product-title').css('height', tallestHeight);
             jQ(this).find('.price-box').css('height', tallestHeight1);
             jQ(this).find('.rug_review').css('height', tallestHeight2);	
    		});
    	});   
    };
    FilterResult.prototype.afterRender = function (data) {
        if (!data) data = this.data;

        //Call func. to align grid items by SM - 786
        gridItemsAlignBySM();

        if (jQ(".boost-pfs-filter-total-products").length > 0 && data.products.length > 0 && Settings.getSettingValue("general.paginationType") !== "load_more") {
            var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
            var to = from + data.products.length - 1;
            var totalProductsSelector = jQ(".boost-pfs-filter-total-products");
            var totalProduct = boostPFSConfig.label.toolbar_showing + " " + from + "-" + to + " " + boostPFSConfig.label.toolbar_of + " " + data.total_product;
            totalProductsSelector.empty().html(totalProduct);
        } else {
            jQ(".toolbar-bottom").hide();
        }
    };
    FilterOptionItem.prototype.buildLabel = function () {
        var filterOption = this.filterOption ? this.filterOption : this.parent;
        var label = Utils.stripHtml(this.label);
        label = label
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#36;/g, "$")
            .replace(/&#x2F;/g, "/");
        var prefix = filterOption.prefix;
        if (typeof label != "string") return "";
        if (typeof prefix == "string") {
            prefix = prefix.replace(/\\/g, "");
            label = label.replace(prefix, "").trim();
        }
        if (label.indexOf("boost-pfs-filter-icon-star") > -1) return label;
        filterOption.displayAllValuesInUppercaseForm = filterOption.displayAllValuesInUppercaseForm || !1;
        if (filterOption.displayAllValuesInUppercaseForm) return label.toUpperCase();
        if (Settings.getSettingValue("general.forceCapitalizeFilterOptionValues")) return Utils.capitalize(label, !0);
        if (Settings.getSettingValue("general.capitalizeFirstLetterFilterOptionValues")) return Utils.capitalize(label, !0, !0);
        if (Settings.getSettingValue("general.capitalizeFilterOptionValues")) return Utils.capitalize(label);
        return Utils.stripHtml(label);
    };
    ProductList.prototype.afterRender = function () {
        if (this.eventType == "filter" || this.eventType == "sort") {
            window.scrollTo({ top: Utils.isMobile() ? jQ(Selector.products).offset().top - 200 : 0, behavior: "smooth" });
        }
    };
})();